import { PersonDetails } from '@weave/schema-gen-ts/dist/schemas/forms-digital/weave_digital_forms.pb';

// Fields collected by the kiosk patron form; used to confirm patron data was already collected before skipping it
const REQUIRED_PATRON_FIELDS: (keyof PersonDetails)[] = [
  'firstName',
  'lastName',
  'birthdate',
  'phoneNumber',
  'streetAddress1',
  'city',
  'state',
  'zipCode',
];

export const hasRequiredPatronData = (person?: PersonDetails): boolean =>
  !!person && REQUIRED_PATRON_FIELDS.every((field) => !!person[field]);
